import React from 'react'
import '../../styles/Utils/Table.css'
import { Table as TableBootstrap } from 'react-bootstrap'

function Table({ data }) {

    return (

        <TableBootstrap striped bordered hover>
            {data.map((item, index) => {
                return (index === 0 ?
                    <thead key={index}>
                        <tr>
                            {item.map((itemCol, indexCol) => {
                                return (
                                    <th key={indexCol} className={indexCol === 0 ? 'tableHeaderFirst' : indexCol === item.length - 1 ? 'tableHeaderLast' : 'tableHeader'}>{itemCol}</th>
                                )
                            })}
                        </tr>
                    </thead>
                    :
                    <tbody key={index}>
                        <tr>
                            {item.map((itemCol, indexCol) => {
                                return (
                                    <th key={indexCol} className={
                                        (index === data.length - 1 && index % 2 === 1 && indexCol === 0) ? 'tableBodyLightFirst'
                                            : (index === data.length - 1 && index % 2 === 1 && indexCol === item.length - 1) ? 'tableBodyLightLast'
                                                : (index % 2 === 1) ? 'tableBodyLight'
                                                    : (index === data.length - 1 && index % 2 === 0 && indexCol === 0) ? 'tableBodyDarkFirst'
                                                        : (index === data.length - 1 && index % 2 === 0 && indexCol === item.length - 1) ? 'tableBodyDarkLast'
                                                            : (index % 2 === 0) ? 'tableBodyDark'
                                                                : null
                                    }>{itemCol}</th>
                                )
                            })}
                        </tr>
                    </tbody>
                )
            })}
        </TableBootstrap>

    )

}

export default Table